export default "__VITE_PUBLIC_ASSET__0aaa1521__"